import styled from "styled-components";

// Svg
import grain from "./../../assets/images/grain.svg";

// Lottie
import Lottie from "lottie-react";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 380px;
  position: absolute;
  height: 780px;
  margin-bottom: 60px;

  /* justify-content: space-between;
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 380px;
  background-color: #463048;
  background-image: url(${grain});
  background-blend-mode: multiply;
  background-size: cover;
  background-repeat: no-repeat;
  height: 780px; */
`;

export const CenterAbout = styled.div`
  background-color: #463048;
  background-image: url(${grain});
  background-blend-mode: multiply;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const HeaderAbout = styled.div`
  text-align: center;
  color: #f8c933;
  font-size: 20px;
  letter-spacing: 1px;
  font-weight: 700;
  margin-top: 10px;
`;

export const Contain = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 380px;
`;

export const MatchBoxStrip = styled.img`
  height: 40px;
  width: 100%;
`;

export const Collector = styled.img`
  height: 90px;
  width: 90px;
  margin-top: -20px;
  margin-right: 200px;
`;

export const Buttons = styled.button`
  background-color: #463048;
  height: 34px;
  width: 34px;
  border: none;
  justify-content: center;
  align-items: center;
  display: flex;
  :active {
    transform: translateY(1px);
  }
  cursor: pointer;
  margin-right: 1.5px;
`;
export const Footer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: -20px;
  margin-right: -145px;
  gap: 5px;
`;

export const TutorialContentArea = styled.div`
  background-color: #463048;
  /* background-image: url(${grain}); */
  background-blend-mode: multiply;
  padding: 10px 16px;
  border-radius: 50px;
  color: white;
  margin-left: 86px;
  margin-top: 24px;
  font-size: 12px;
  font-weight: 600;
  width: 205px;
  position: absolute;
  text-align: center;

  /* margin-left: 400px; */
  &:before {
    content: "";
    width: 0px;
    height: 0px;
    background-image: url(${grain});
    position: absolute;
    border-left: 0px solid #463048;
    border-right: 16px solid transparent;
    border-top: 14px solid #463048;
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    left: 8px;
    bottom: 38px;
    border-radius: 10px 0 0 0;
  }
`;

export const LottieAnimation = styled(Lottie)`
  height: 170px;
  width: 170px;
`;
export const LottieAnimationDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ImageDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;
export const P = styled.div`
  margin: 0px;
  font-size: 12px;
  text-align: center;
  color: #f8c933;
  margin-bottom: 20px;
  padding-left: 10px;
  padding-right: 10px;
`;
export const Anchor = styled.a`
  color: #f8c933;
  text-decoration: underline;
  font-weight: 400;
  cursor: pointer;
  padding-left: 20px;
  padding-right: 20px;
`;
export const Div = styled.div`
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: flex;
`;
export const OuterDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 380px;
  margin-top: 10px;
  margin-bottom: 10px;
`;
export const DivButton = styled.button`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  cursor: pointer;
`;
export const ButtonImg = styled.img`
  width: 30px;
  height: 30px;
`;
